import React, {Component} from "react";
import { connect } from "react-redux";

import CatagoryItem from './catagoryItem';
import { fetchAllCatagories } from "../../redux/actions";
import _ from 'lodash';

import "./catagory.css";

class CatagoryPanel extends Component {
  constructor(props){
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount(){
    this.props.fetchAllCatagories().then(()=>{
      this.setState({
        loading: false
      });
    });
  }

  render() {
    if(this.state.loading){
      return( <div>Please wait while we prepare some flowers for you</div>
      )
    }
    else{
      let catagorylist = this.props.catagorylist
      let orderedCatagorylist = _.orderBy(catagorylist, ['name'], ['asc']);
      // let temp = orderedCatagorylist[8];
      // let temp2 = orderedCatagorylist[9];
      // let temp3 = orderedCatagorylist[7];
      // let temp4 = orderedCatagorylist[10];
      // let temp5 = orderedCatagorylist[6];
      // orderedCatagorylist[6] = temp;
      // orderedCatagorylist[7] = temp2;
      // orderedCatagorylist[8] = temp3;
      // orderedCatagorylist[9] = temp4;
      // orderedCatagorylist[10] = temp5;
  
      let Catagorylist = orderedCatagorylist.filter((item) => item.name !== 'All').map((item, index) => {
      
          return(
            <CatagoryItem
              key={index}
              imageURL={item.imageURL}
              // imageURL = { "http://www.independentmediators.co.uk/wp-content/uploads/2016/02/placeholder-image.jpg" }
              cataName={item.name}/>);
      });
  
      return (
        <div className="catagoryPanel container">
          <div id="catagoryPanelCaption"><h1>categories</h1></div>
          <div className="catagoryContainer row">
            {Catagorylist}
          </div>
        </div>
      );
    }
    
  }
}

function mapStateToProps(state) {
  return({
    catagorylist: state.catagorylist
  });
}

export default connect(mapStateToProps, {fetchAllCatagories})(CatagoryPanel);



// WEBPACK FOOTER //
// ./src/components/catagory/catagoryPanel.js